import React from 'react';
import supereth from '../assets/supereth.png';

export default function Card(card) {
  return (
    <div className='card'>
      <div className="card-image">
        <img src={card.image} alt="image" />
      </div>
      <div className="card-content">
        <div className="card-heading">
          <span className="card-series">{card.series}</span>
          <span className='card-top'>Top bid</span>
        </div>
        <div className="card-details">
          <h4 className="card-title">{card.title}</h4>
          <div className="card-price">
            <img src={supereth} alt="supereth" />
            <span>{card.price}</span>
          </div>
        </div>
        <div className="card-sub-details">
          <span>#{card.tag}</span>
          <span>{card.time} day left</span>
        </div>
      </div>
    </div>
  )
}
